import React from "react";
import "./CanaanVideo.css"; // Assuming you'll place your CSS in a separate file
import AnexMinerET5Video from "../../../../assets/Canaan/55.mp4"; // Import the video source

const CanaanVideo = () => {
  return (
    <div className="mine-thunder-canaan-one-products-container">
      <div className="mine-thunder-canaan-one-products-left">
        <video
          className="mine-thunder-canaan-one-products-video"
          src={AnexMinerET5Video}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
      <div className="mine-thunder-canaan-one-products-right">
        <div className="mine-thunder-canaan-one-products-small-title">
          Avalon Made
        </div>
        <div className="mine-thunder-canaan-one-products-big-title">
          Canaan A1466 – 150T
        </div>
        <div className="mine-thunder-canaan-one-products-text">
          <p>
            The Avalon Made A1466 – 150T is a powerhouse in the mining hardware
            arena, setting a new standard with its exceptional hash rate of 150
            terahashes per second. This miner's unparalleled performance is
            matched by its energy efficiency, striking a remarkable balance by
            delivering such impressive output while consuming relatively lower
            power. Its cutting-edge technology and optimized design ensure
            optimal mining capabilities, making it an ideal choice for those
            aiming for high-performance mining operations without excessive
            energy overheads.
          </p>
          <p>
            Beyond its remarkable technical specifications, the A1466 – 150T
            embodies reliability and durability, attributes highly coveted in
            the demanding landscape of cryptocurrency mining. Its robust
            construction and proven track record in maintaining stable and
            consistent performance further solidify its position as a top-tier
            choice among miners. With its blend of superior hashing power,
            energy efficiency, and reliability, the A1466 – 150T continues to
            assert itself as a dominant force, catering to the needs of both
            seasoned miners and newcomers seeking a reliable and
            high-performance mining solution.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CanaanVideo;
